import { render, staticRenderFns } from "./PortalDoClienteUserList.vue?vue&type=template&id=65e41534&scoped=true"
import script from "./PortalDoClienteUserList.vue?vue&type=script&lang=js"
export * from "./PortalDoClienteUserList.vue?vue&type=script&lang=js"
import style0 from "./PortalDoClienteUserList.vue?vue&type=style&index=0&id=65e41534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e41534",
  null
  
)

export default component.exports